/**
 * Converts a canvas-space pointer delta into a pre-rotation local space by applying the inverse
 * of `rotationDeg`. For a pure delta/direction vector (as opposed to a point) there is no pivot to
 * account for, so this is a plain rotation. Returns the delta unchanged when the rotation is 0.
 */
export function rotateDeltaToLocal(
  dx: number,
  dy: number,
  rotationDeg: number
): { dx: number; dy: number } {
  if (!rotationDeg) return { dx, dy }

  const θ = (rotationDeg * Math.PI) / 180
  const cosR = Math.cos(θ)
  const sinR = Math.sin(θ)

  return {
    dx: dx * cosR + dy * sinR,
    dy: -dx * sinR + dy * cosR,
  }
}
